import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Col,
  Row,
  Space,
  Input,
  Table,
  Switch,
  Button,
  Upload,
  Avatar,
  Empty,
} from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { showNotification } from "../utils/commonFunctions";
import {
  UploadOutlined,
  DeploymentUnitOutlined,
  DeliveredProcedureOutlined,
  SaveOutlined,
  SendOutlined,
  QuestionCircleOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  MessageOutlined,
  PlusOutlined
} from "@ant-design/icons";
import axios from "axios";
import AppUrl from "../config/appUrl";
import OpenAiChatItem from "../openAiChat/components/OpenAiChatItem";
import SetTrainingPromptModal from "./SetTrainingPromptModal";
import { useLocation } from "react-router-dom";
import appUrl from "../config/appUrl";
import moment from "moment-timezone";
import SetMessageModal from "./SetMessageModel";

const TrainingBot = () => {
  const location = useLocation();
  // console.log("--------", location?.state)
  const [state, setState] = useState({
    message: "",
    text: "",
    showDefaultResponse: false,
  });
  const [open, setOpen] = useState(false);
  const [openPrompt, setOpenPrompt] = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileUrlList, setFileUrlList] = useState([]);
  const [messages, setMessages] = useState([]);
  const [textFromFiles, setTextFromFiles] = useState({});
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [hideChatInput, setHideChatInput] = useState(false);
  const [loadingOne, setLoadingOne] = useState(false);
  const [loadingTwo, setLoadingTwo] = useState(false);
  const messageRefs = useRef([]);
  const [toggleState, setToggleState] = useState(1);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    const data = location?.state;
    axios
        .get(appUrl.FETCH_KNOWLEDGE + `?tenant_id=${data?.tenant_id}&bot_id=${data?.bot_id}`)
        .then((resp) => {
          const FileParams = resp.data?.documents?.map(o=>{
            return {
              name: o.file_name,
              id: o.document_id,
              mimeType: o?.file_name?.includes(".pdf") ? "application/pdf" : "text/plain",
              extension: o?.file_name?.includes(".pdf") ? ".pdf" : ".txt",
              status: true,
            }
          });
          setFileList(FileParams || []);
        }).catch((err) => {
          console.log(err);
          showNotification("error", "Failed to fetch file data");
        })
        axios
            .get(appUrl.FETCH_PROMPT + `?tenant_id=${data?.tenant_id}&bot_id=${data?.bot_id}`)
            .then((resp) => {
              let custom_prompt = resp?.data?.prompts?.map((o, i)=>{
                return {
                  index: i,
                  value: o?.messages?.[0]?.content,
                  created_at: o?.created_at //o.timestamp
                }
              })
          setState((preState) => ({
            ...preState,
            prompt: custom_prompt,//res.data?.data?.prompt,
            custom_message: null,//res.data?.data?.error_message,
          }));
      })
      .catch((err) => {
        console.log(err);
        showNotification("error", "Failed to fetch file data");
      });
  };

  const saveData = (customMessage, type, action) => {
    console.log(fileList, customMessage, type);
    setState((preState) => ({
      ...preState,
      loading: true,
      val: "",
      type: "",
    }));

    if (fileUrlList.length > 0) {
      //   let formData = new FormData();
      //   fileList.map((o, i)=>formData.append("files", o))
      //   axios.post(appUrl.UPLOAD, formData).then(response=>{
      //     const file = response?.data?.data?.urls || [];
      //     console.log("Files",file)
      saveText(customMessage, type, fileUrlList, action);
      // }).catch(err=>showNotification("error", err.message || "Failed to upload file"))
    } else {
      saveText(customMessage, type, null, action);
    }
  };

  const saveText = (customMessage, type, file, action) => {
    const data = location?.state;
    let url = "";
    let payload = {};
    if (state.text) {
      payload.text = state.text.trim();
      url = "https://chatbot.ibism.com/chat/upload_data"
    }
    // if (type === "custom_message" && typeof customMessage === "string") {
    //   payload = { email: email, customMessage: customMessage };
    // }
    if (type === "prompt") {
      payload = customMessage;
    //   payload.text = undefined;
      url = appUrl.FETCH_PROMPT + `?tenant_id=${data?.tenant_id}&bot_id=${data?.bot_id}`
    }
    // if (file) {
    //   payload.files = file;
    // }


    if(action === "create") {
      axios
          .post(url, payload)
          .then((res) => {
            showNotification("success", res?.data?.message);
            console.log(payload)
            setState((preState) => ({
              ...preState,
              loading: false,
              val: "",
              type: "",
              prompt: [...preState.prompt, {index: preState?.prompt?.length+1, value:res?.data?.prompt?.content, created_at:payload?.created_at}]
            }));
          })
          .catch((err) => {
            console.log(err);
            showNotification("error", "Failed to save file data");
          });
    }
    if(action === "edit") {
      axios
          .put(url + `&created_at=${payload?.created_at}`, payload)
          .then((res) => {
            showNotification("success", res?.data?.message);
            setState((preState) => ({
              ...preState,
              loading: false,
              val: "",
              type: "",
              prompt: preState?.prompt.map((o) => {
                if(o.created_at === payload.created_at){
                  o.value = payload?.prompt?.content;
                }
                return o;
              })
            }));
            getData();
          })
          .catch((err) => {
            console.log(err);
            showNotification("error", "Failed to save file data");
          });
    }
    if (action === "delete") {
      axios
          .delete(url + `&created_at=${payload?.created_at}`)
          .then((res) => {
            showNotification("success", res?.data?.message);
            // if (res.data.success) {
            setState((preState) => ({
              ...preState,
              loading: false,
              val: "",
              type: "",
              prompt: preState?.prompt.filter((o) => o.created_at !== payload.created_at)
            }));
            //   getData();
            // }
          })
          .catch((err) => {
            console.log(err);
            showNotification("error", "Failed to save file data");
          });
    }

  };

  const updateImageUpload = useCallback(({ file }) => {
    const data = location?.state
    setState((prevState) => ({ ...prevState, loading: true }));
    let formData = new FormData();
    formData.append("file", file);
    axios
      .post(appUrl.FETCH_KNOWLEDGE + `?tenant_id=${data?.tenant_id}&bot_id=${data?.bot_id}`, formData)
      .then((response) => {
        showNotification("success", response?.data?.message);
        const FileParams = {
              name: file?.name,
              id: response.data?.document_id,
              mimeType: file?.name?.includes(".pdf") ? "application/pdf" : "text/plain",
              extension: file?.name?.includes(".pdf") ? ".pdf" : ".txt",

        }

        setFileList((prevState)=>[...prevState, FileParams])

        setState((prevState) => ({ ...prevState, loading: false }));
      })
      .catch((err) => showNotification("error", err.message || "Failed to upload file"));
  }, []);

  const onRemoveImage = useCallback((file) => {
    const data = location?.state
    const fileId = file?.id;
    axios
        .delete(appUrl.FETCH_KNOWLEDGE + `/${file?.id}?tenant_id=${data?.tenant_id}&bot_id=${data?.bot_id}`)
        .then((response) => {
          showNotification("success", response?.data?.message);
          setFileList((preState) => preState.filter((p) =>  p?.id !== fileId));
          setState((prevState) => ({ ...prevState, loading: false }));
        })
        .catch((err) => showNotification("error", err.message || "Failed to upload file"));


  }, []);

  const handleChange = useCallback(
    (name) => (e) => {
      let value = e?.target?.value ?? e;

      setState((prevState) => {
        prevState[name] = value;
        return { ...prevState };
      });
    },
    []
  );

  const onSend = useCallback(() => {
    const data = location?.state
    let message = state.message.trim();
    const text = state.text.trim();

    /* if (!message) return;
    if (!text) return; */

    const newMessages = messages;
    newMessages.push({
      role: "user",
      content: message,
    });
    // const custom_message = localStorage.getItem("custom_message");

    const payload = {
      query: message,
      // text: text,
      // user_id: location?.state?.email,
      // customMessage: custom_message,
      session_id: `session_id_${global.ipaddress}`,
    };

    newMessages.push({
      role: "assistant",
      content: "typing...",
      loading: true,
    });

    setMessages(newMessages);
    setState((prevState) => ({ ...prevState, message: "", loading: true }));

    const lastMessageIndex = messages.length - 1;
    setTimeout(
      () =>
        messageRefs?.current?.[lastMessageIndex]?.scrollIntoView?.({
          behavior: "smooth",
        }),
      100
    );

    axios.post(appUrl.TENANT + `/${data?.tenant_id}/bots/${data?.bot_id}/chat?tenant_id=${data?.tenant_id}&bot_id=${data?.bot_id}`,payload)
      .then((response) => {
        const resData = response.data;
        // console.log(resData);

        if (!resData?.response) {
          setMessages((prevMessages) => {
            const lastMesssage = prevMessages.pop();
            console.log("remove message: ", lastMesssage);

            return [...prevMessages];
          });
        } else {
          const newMessage = {};
          let content = resData?.response;
          while (content.startsWith("\n")) {
            content = content.replace("\n", "");
          }
          newMessage.content = content;

          setTimeout(
            () =>
              messageRefs?.current?.[lastMessageIndex + 1]?.scrollIntoView?.({
                behavior: "smooth",
              }),
            100
          );

          setMessages((prevMessages) => {
            prevMessages.pop();

            return [...prevMessages, newMessage];
          });
        }

        setState((prevState) => ({ ...prevState, loading: false }));
      })
      .catch((err) => {
        console.log("chat err: ", err);
        showNotification("error", "Something went wrong");
        setMessages((prevMessages) => {
          const lastMesssage = prevMessages.pop();
          console.log("remove message: ", lastMesssage);

          return [...prevMessages];
        });
        setState((prevState) => ({ ...prevState, loading: false }));
      });
  }, [state.message, state.text, messages]);

  const handleUserModal = useCallback((show = false) => {
    show = typeof show === "boolean" && show;
    setOpenPrompt(show);
    setState((prev) => ({ ...prev, type: "", val: "" }));
  }, []);

  const toggleTab = useCallback((index) => {
    setToggleState(index);
  }, []);

  const deletePrompt = (val) => {
    console.log(val)
    saveData(val, "prompt", "delete");
    // showNotification("success", "Successfully data deleted!");
  };
  const editPrompt = (val) => {
    setOpenPrompt(true);
    // saveData(val, "prompt", "edit");
    setState((prev) => ({ ...prev, type: "edit", val: val }));
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";
// console.log(fileUrlList)

  const handlePreview = useCallback((file) => {
    console.log("handlePreview", file);
    // url: appUrl.FETCH_KNOWLEDGE + `/${o.ducument_id}?tenant_id=${data?.tenant_id}&bot_id=${data?.bot_id}`,

  },[]);

  console.log("----->",state)

  return (
    <>
      <Row justify="space-between" className="listing-cb">
        <div style={{ width: "100%", paddingBottom: "50px" }}>
          <Col xs={24} className="bot-training">
            <div className="tabs">
              <div
                className={`tab-label ${getActiveClass(1, "active-tabs")}`}
                onClick={() => toggleTab(1)}
              >
                <DeploymentUnitOutlined style={{ marginRight: "3px" }} />{" "}
                Training Data
              </div>
              <div className={`panel ${getActiveClass(1, "active-content")}`}>
                <Row
                  className="mb15"
                  justify={"space-between"}
                  style={{ flexFlow: "initial" }}
                >
                  <Col style={{ flex: "1 0 0%", paddingRight: "30px" }}>
                    <Upload
                      className="upload-list-inline"
                      showUploadList={true}
                      accept={".pdf,.txt"}
                      listType="picture"
                      fileList={fileList}
                      onRemove={onRemoveImage}
                      onPreview={handlePreview}
                      customRequest={updateImageUpload}
                      disabled={state.loading}
                    >
                      <Button
                        type="primary"
                        loading={state?.loading}
                        icon={<UploadOutlined />}
                        size="large"
                        style={{ minWidth: "160px" }}
                      >
                        {" "}
                        Upload File
                      </Button>

                    </Upload>
                  </Col>
                  {/*<Col style={{ flex: "0 0 auto", width: "auto" }}>*/}
                  {/*  <Button*/}
                  {/*    type="primary"*/}
                  {/*    icon={<SaveOutlined />}*/}
                  {/*    size="large"*/}
                  {/*    style={{ minWidth: "160px" }}*/}
                  {/*    // onClick={saveData}*/}
                  {/*      onClick={()=>showNotification("error", "Only upload functionality is working")}*/}
                  {/*    disabled={state.loading}*/}
                  {/*  >*/}
                  {/*    {" "}*/}
                  {/*    Save Data*/}
                  {/*  </Button>*/}
                  {/*</Col>*/}
                </Row>

                <Row>
                  <Col className="--right-container" xs={24} lg={16}>
                    <Col className="sticky h-full top-0">
                      <Col className="">
                        <Row className=" h-full">
                          {/* <Input.TextArea
                      className=" input-text-editor grow-1"
                      value={state.text}
                      placeholder="Provide text or knowledge base here to train your  model."
                      onChange={handleChange("text")}
                      //   autosize={{ minRows: 15, maxRows: 19 }}
                      onPressEnter={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          handleChange("text");
                        }
                      }}
                      disabled={state.loading}
                      size="large"
                    /> */}

                          <ReactQuill
                            style={{
                              height: "560px",
                              marginBottom: "50px",
                              width: "100%",
                            }}
                            placeholder={
                              "Provide text or knowledge base here to train your  model."
                            }
                            value={state.text}
                            disabled={true}
                            onChange={handleChange("text")}
                            theme="snow"
                          />
                        </Row>
                      </Col>
                    </Col>
                  </Col>

                  <Col xs={24} lg={8}>
                    <div className="bot-cb-main">
                      <div className="center-frame">
                        <div className="tab-frame-cbs">
                          <div className="tab-inner-frame-cb">
                            <div className="tab-inner-frame-top">
                              <Col
                                className=""
                                style={{
                                  height: "518px",
                                  overflowY: "auto",
                                  paddingRight: "5px",
                                  paddingTop: "10px",
                                }}
                              >
                                {/* chat container start */}
                                <Col className="chat-container h-4/6">
                                  <Col className="message-list-container">
                                    <Row className="chat-item-container">
                                      <Col>
                                        <Avatar
                                          size={40}
                                          shape={"circle"}
                                          style={{
                                            backgroundColor:
                                              "rgb(255, 161, 108)",
                                          }}
                                        >
                                          {"Bot"}
                                        </Avatar>
                                      </Col>

                                      <Col className="chat-details-container">
                                        <Row
                                          className="user-details"
                                          align="middle"
                                          justify="space-between"
                                        >
                                          {/* <span className="name">{createdBy.name ?? "Bot"}</span> */}
                                          <span className="name">
                                            {location?.state?.bot_name}
                                          </span>
                                          <span>
                                            Hello 👋, I'm the{" "}
                                            {location?.state?.bot_name} bot, ready
                                            to help! 😊 Feel free to share your
                                            inquiry with me.
                                          </span>
                                        </Row>
                                      </Col>
                                    </Row>
                                    {/* <div className="defaultMsg">
                          <p>
                            Hello 👋, I'm the Fit2Trip bot, ready to help! 😊
                          </p>
                          <p>Feel free to share your inquiry with me. </p>
                        </div> */}
                                    {messages?.map?.((message, i) => (
                                      <div
                                        key={i}
                                        ref={(mRef) =>
                                          (messageRefs.current[i] = mRef)
                                        }
                                      >
                                        <OpenAiChatItem
                                          key={i}
                                          state={location?.state}
                                          message={message}
                                        />
                                        <Row justify="end" align="">
                                          {message.content ===
                                            "Sorry we could not find detail about your query. Please contact our support team at help@oben.com | +91 1232123212." && (
                                            <Col
                                              style={{
                                                marginRight: "20px",
                                                marginTop: "-110px",
                                              }}
                                            >
                                              {/* <Button>
                                    <MailOutlined onClick={handleSendEmail} />
                                  </Button> */}
                                            </Col>
                                          )}
                                        </Row>
                                      </div>
                                    ))}

                                    {/* {!messages.length && (
                          <Row
                            className="h-full"
                            align="middle"
                            justify="center"
                          >
                            <div className="defaultMsg">
                              <p>
                                Hello 👋, I'm the Fit2Trip bot, ready to help!
                                😊
                              </p>
                              <p>Feel free to share your inquiry with me. </p>
                            </div>
                          </Row>
                        )} */}
                                  </Col>
                                </Col>
                                {/* chat container end */}
                              </Col>

                              <Col className="mt20">
                                {/* chat input container end */}
                                <Row align="middle" wrap={false}>
                                  <Col className="grow">
                                    <Input
                                      className="chat-input"
                                      value={state.message}
                                      placeholder="Enter your prompt"
                                      onChange={handleChange("message")}
                                      autosize={{ minRows: 1, maxRows: 4 }}
                                      onPressEnter={(e) => {
                                        if (e.key === "Enter" && !e.shiftKey) {
                                          onSend();
                                        }
                                      }}
                                      disabled={state.loading}
                                      size="large"
                                    />
                                  </Col>
                                  <Button
                                    className="text-2xl btn-color"
                                    type="text"
                                    onClick={onSend}
                                    disabled={!state.message.trim()}
                                    loading={state.loading}
                                    size="large"
                                    icon={<SendOutlined className="text-3xl" />}
                                  />
                                </Row>
                                {/* chat input container end */}
                              </Col>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div
                className={`tab-label ${getActiveClass(2, "active-tabs")}`}
                onClick={() => toggleTab(2)}
              >
                <DeliveredProcedureOutlined style={{ marginRight: "3px" }} />{" "}
                Prompt Template
              </div>
              <div className={`panel ${getActiveClass(2, "active-content")}`}>
                <Row className="mb15" style={{ flexFlow: "initial" }}>
                  <Col xs={24} align="end">
                    <Row>
                      <Col xs={24} align="end">
                        <Space>
                          <Button
                            type="primary"
                            icon={<PlusCircleOutlined />}
                            size="large"
                            loading={state?.loading}
                            style={{ minWidth: "160px" }}
                            onClick={() => handleUserModal(true)}
                          >
                            {" "}
                            Add Prompt
                          </Button>

                          {/*<Button*/}
                          {/*  type="primary"*/}
                          {/*  icon={<PlusCircleOutlined />}*/}
                          {/*  size="large"*/}
                          {/*  loading={state?.loading}*/}
                          {/*  style={{ minWidth: "160px" }}*/}
                          {/*  onClick={() => setOpenMessage(true)}*/}
                          {/*>*/}
                          {/*  {" "}*/}
                          {/*  Add Custom Message*/}
                          {/*</Button>*/}
                        </Space>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {state?.prompt && state?.prompt.length === 0 && (
                  <div className="empty-container">
                    <Empty />
                  </div>
                )}

                {state?.prompt &&
                  state?.prompt.length !== 0 &&
                  state?.prompt.map((o) => {
                    return (
                      <Row key={o.created_at} className="task-row-item-o-cb">
                        <Col xs={24}>
                          <div className="task-row-item-card">
                            <div className="task-content">{o.value}</div>

                            <div className="task-icons">
                              <Row>
                                <Space>
                                  <div className="task-created">
                                    <span>
                                      Created on{" "}
                                      {moment.utc(o.created_at).format("DD MMM YYYY")}
                                    </span>
                                  </div>
                                  <EditOutlined
                                    onClick={() => editPrompt(o)}
                                    style={{
                                      fontSize: "16px",
                                      color: "#2a2a2a",
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                  />
                                  <DeleteOutlined
                                    onClick={() => deletePrompt(o)}
                                    style={{
                                      fontSize: "16px",
                                      color: "#2a2a2a",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Space>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
              </div>
            </div>
          </Col>
        </div>
      </Row>
      {/*<SetMessageModal*/}
      {/*  open={openMessage}*/}
      {/*  handleModal={setOpenMessage}*/}
      {/*  save={saveData}*/}
      {/*/>*/}

      <SetTrainingPromptModal
        val={state?.val}
        type={state?.type}
        state={state}
        open={openPrompt}
        handleModal={handleUserModal}
        save={saveData}
      />
    </>
  );
};

export default TrainingBot;
